module.exports = __webpack_public_path__ + "static/media/service-icon-1.b51f7db7.webp";